import { defineStore } from 'pinia';
const path = import.meta.env.VITE_APP_URL+'poll';

export const usePollStore = defineStore('poll', {
  state: () => ({
    polls: [],
    currentPoll: null,
    pollResults: {},
  }),
  persist: true,

  getters: {
    getPolls: (state) => state.polls,
    getPollById: (state) => (id) => state.polls.find((poll) => poll.id === id),
    getPollResults: (state) => (pollId) => state.pollResults[pollId],
  },

  actions: {
    async createPoll(pollData) {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.post(path, pollData);
        this.polls.push(response.data);
        return response.data;
      } catch (error) {
        console.error('Error creating poll:', error);
        throw error;
      }
    },

    async fetchPolls() {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.get(path);
        this.polls = response.data;
        return response.data;
      } catch (error) {
        console.error('Error fetching polls:', error);
        throw error;
      }
    },

    async fetchPollById(pollId) {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.get(path + `/${pollId}`);
        this.currentPoll = response.data;
        return response.data;
      } catch (error) {
        console.error('Error fetching poll:', error);
        throw error;
      }
    },

    async updatePoll({ pollId, pollData }) {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.put(path + `/${pollId}`, pollData);
        const index = this.polls.findIndex((poll) => poll.id === pollId);
        if (index !== -1) {
          this.polls.splice(index, 1, response.data);
        }
        return response.data;
      } catch (error) {
        console.error('Error updating poll:', error);
        throw error;
      }
    },

    async deletePoll(pollId) {
      try {
        const { default: axios } = await import('axios');
        await axios.delete(path + `/${pollId}`);
        this.polls = this.polls.filter((poll) => poll.id !== pollId);
      } catch (error) {
        console.error('Error deleting poll:', error);
        throw error;
      }
    },

    async submitPollResponse({ pollId, responseData }) {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.post(path + `/${pollId}/responses`, responseData);
        const poll = this.polls.find((p) => p.id === pollId);
        if (poll) {
          if (!poll.responses) poll.responses = [];
          poll.responses.push(response.data);
        }
        return response.data;
      } catch (error) {
        console.error('Error submitting poll response:', error);
        throw error;
      }
    },

    async fetchPollResults(pollId) {
      try {
        const { default: axios } = await import('axios');
        const response = await axios.get(path + `/${pollId}/results`);
        this.pollResults = { ...this.pollResults, [pollId]: response.data };
        return response.data;
      } catch (error) {
        console.error('Error fetching poll results:', error);
        throw error;
      }
    },
  },
});
